import React from 'react';
import logo from '../../res/images/neosvoc-logo.svg';

const Home = () => (
    <div className="container home">
        <a href="https://www.neosvoc.com/">
            <img src={logo} alt="NeosVoc" title="NeosVoc" />
        </a>
    </div>
);

export default Home;
